export class CreateUserResult {
  public success: boolean;
  public userId: string;
}
